import styles from './index.module.scss';

interface InputProps {
    name: string;
    label: string;
    placeholder: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled: boolean;
    value: string | null;
}

const Input: React.FunctionComponent<InputProps> = (props) => {
    const { label, placeholder, name, onChange, disabled, value } = props;

    return (
        <div className={styles.input_wrapper}>
            <span className={styles.input_label}>{label}</span>
            <input
                name={name}
                placeholder={placeholder}
                className={styles.input_field}
                onChange={(e) => onChange(e)}
                disabled={disabled}
                value={value ? value : ''}
            />
        </div>
    );
}

export default Input;